"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getGlobal = _interopRequireDefault(require("../../utils/getGlobal")); // Expects we've set up Index Exchange's JS.


var _default = function _default() {
  var global = (0, _getGlobal.default)();
  var headertag = global.headertag || {};
  headertag.cmd = headertag.cmd || []; // We're not running in global scope, so make sure to
  // assign to the global.

  if (!global.headertag) {
    global.headertag = headertag;
  }

  return global.headertag;
};

exports.default = _default;